import {indent} from '/constant/layout.constant';

export const styles = {
  webContainer: {
    paddingVertical: 0,
    marginBottom: 0,
  },
  webHeader: {
    marginTop: indent * 0.25,
    marginBottom: indent * 0.35,
  },
};
